import React, { memo, forwardRef, useState, useRef } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fr from "date-fns/locale/fr";
import { parse, isValid } from "date-fns";
import "./DatePickerInput.css";
import ReactInputMask from "react-input-mask";
import { formatDate } from "../../../common/utils";
import { languageSelector } from "../../../features/language/languageSlice";
import { useSelector } from "react-redux";
var TodaysDate = new Date();
var dd = String(TodaysDate.getDate()).padStart(2, "0");
var mm = String(TodaysDate.getMonth() + 1).padStart(2, "0"); //January is 0!
var yyyy = TodaysDate.getFullYear();
TodaysDate = mm + "/" + dd + "/" + yyyy;

function RangePickerInput(props) {
  registerLocale("fr", fr);
  const inputRef = useRef(null);
  const lang = useSelector(languageSelector);
  return (
    <>
      <div className="flex flex-row w-[330px]">
        <div>
          <h1 class="font-bold pb-1.5 pt-2">Date From</h1>
          <DatePicker
            locale={lang?.value === "fr" ? "fr" : ""}
            customInput={
              <CustomInput
                dynamicPicker={props.dynamicPicker}
                inputRef={inputRef}
                value={props.value[0]}
                typeDate={(date) => {
                  if (props.onChange) {
                    props.onChange([date, props.value[1]]);
                  }
                }}
              />
            }
            className="custom__datepicker bg-white border w-full p-2.5 relative w-[300px]"
            maxDate={ props.value[1] ? new Date(props.value[1].getTime() - 86400000) : undefined }
            placeholderText={TodaysDate}
            selectsStart
            startDate={props.value[0]}
            endDate={props.value[1]}
            onChange={(date) => {
              if (props.onChange) {
                props.onChange([date, props.value[1]]);
              }
            }}
            value={props.value}
            selected={props.value[0]}
            showMonthDropdown
            showYearDropdown
            dropdownMode="scroll"
            dayClassName={(date) => (date ? "datepicker-cell" : "")}
            type="date"
            dateFormat="dd/MM/yyyy"
          />
        </div>
        <div className="mr-2">
          <img
            src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMiIgdmlld0JveD0iMCAwIDEwIDIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxsaW5lIHkxPSIxLjI1IiB4Mj0iMTAiIHkyPSIxLjI1IiBzdHJva2U9IiMyMzFGMjAiIHN0cm9rZS13aWR0aD0iMS41Ii8+Cjwvc3ZnPgo="
            class="align-middle justify-center ml-2 mr-2 mt-14 z-50"
            alt=""
            width="10px"
          />
        </div>
      </div>
      <div>
        <h1 class="font-bold pb-1.5 pt-2">Date To</h1>
        <DatePicker
          locale={lang?.value === "fr" ? "fr" : ""}
          customInput={
            <CustomInput
              dynamicPicker={props.dynamicPicker}
              inputRef={inputRef}
              value={props.value[1]}
              typeDate={(date) => {
                if (props.onChange) {
                  props.onChange([props.value[0], date]);
                }
              }}
            />
          }
          className="custom__datepicker bg-white border w-full p-2.5 relative w-[234px]"
          placeholderText={TodaysDate}
          selectsEnd
          minDate={props.value[0]}
          startDate={props.value[0]}
          endDate={props.value[1]}
          onChange={(date) => {
            if (props.onChange) {
              props.onChange([props.value[0], date]);
            }
          }}
          value={props.value}
          selected={props.value[1]}
          showMonthDropdown
          showYearDropdown
          dropdownMode="scroll"
          dayClassName={(date) => (date ? "datepicker-cell" : "")}
          type="date"
          dateFormat="dd/MM/yyyy"
        />
      </div>
      {/* {props?.dateRange && (
        <div
          className="flex flex-row items-center  pl-1 mt-2"
          aria-labelledby="date_range"
          role="application"
        >
          <input
            id="date_range"
            type="checkbox"
            value="date range"
            name="date_range"
            className="custom__checkbox custom__checkbox-multiple h-4 pl-2 relative w-4"
            onChange={() => props?.setDatePicker((prev) => !prev)}
            checked={props?.datepicker}
          />
          <label for="date_range" className="font-normal ml-2">
            Date Range
          </label>
        </div>
      )} */}
    </>
  );
}

export default memo(RangePickerInput);

export const CustomInput = forwardRef(
  ({ value, onClick, onFocus, onChange, dynamicPicker, typeDate }, ref) => {
    const handleInputChange = (e) => {
      // e.preventDefault();
      // const inputValue = e.target.value;

      // const parsedDate = parse(inputValue, "dd/MM/yyyy", new Date());

      // if (isValid(parsedDate)) {
      //   typeDate(parsedDate);
      // } else {
      //   const today = new Date();
      //   typeDate(today);
      //   e.target.value = formatDate(today); // Assuming formatDate formats to dd/MM/yyyy
      // }
      const inputValue = e.target.value;

      const dateFormatRegex =
        /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;

      if (dateFormatRegex.test(inputValue)) {
        const [day, month, year] = inputValue.split("/");
        const jsDate = new Date(year, month - 1, day);
        typeDate(jsDate);
      }

      //trigger && fieldName && trigger(fieldName);
    };
    return (
      <>
        <div
          className={
            dynamicPicker ? "flex flex-row w-[388px]" : "flex flex-row"
          }
        >
          <div
            className={
              dynamicPicker
                ? "datepicker relative w-[388px]"
                : "datepicker relative"
            }
          >
            <ReactInputMask
              type="text"
              className="custom__datepicker bg-white border w-full p-2.5"
              placeholder="dd/mm/yyyy"
              onClick={onClick}
              onFocus={onFocus}
              onChange={handleInputChange}
              value={value}
              // onBlur={handleInputChange}
              ref={ref}
              mask="99/99/9999"
              maskChar={" "}
              dateFormat="dd/MM/yyyy"
            />

            <div className="datepicker__icon absolute inset-y-0 left-0 flex items-center pointer-events-none">
              <svg
                aria-hidden="true"
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_2142_5044)">
                  <path
                    d="M13.7979 2.48755H3.02058C2.17027 2.48755 1.48096 3.14881 1.48096 3.96451V14.3032C1.48096 15.1189 2.17027 15.7802 3.02058 15.7802H13.7979C14.6482 15.7802 15.3375 15.1189 15.3375 14.3032V3.96451C15.3375 3.14881 14.6482 2.48755 13.7979 2.48755Z"
                    stroke="#595959"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M11.4888 1.0105V3.96442"
                    stroke="#595959"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M5.33008 1.0105V3.96442"
                    stroke="#595959"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M1.48096 6.91846H15.3375"
                    stroke="#595959"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </g>
                <defs>
                  <clippath id="clip0_2142_5044">
                    <path
                      d="M0 1C0 0.447715 0.447715 0 1 0H16.4091V16.7907H0.999999C0.447714 16.7907 0 16.343 0 15.7907V1Z"
                      fill="white"
                    ></path>
                  </clippath>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </>
    );
  }
);
